// import ColorManipulator from 'material-ui/utils/colorManipulator';
import {
  cyan500,
  cyan700,
  grey100,
  grey300,
  grey400,
  grey500,
  // pinkA200,
  white,
  // darkBlack,
  // fullBlack,
} from 'material-ui/styles/colors';

export default {
  spacing: {
    smallIconSize: 18,
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 16,
    desktopLeftNavMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
  zIndex: {
    popover: 2000,
    appBar: 1100,
    leftNavOverlay: 1200,
    leftNav: 1300,
    dialogOverlay: 1400,
    dialog: 1500,
    layer: 2000,
    tooltip: 3000,
    menu: 1000,
    snackbar: 9900,
  },
  tabs: {
    textColor: '#0a0a0a',
    selectedTextColor: '#784cab',
  },
  selectedTextColor: '#784cab',
  slider: {
    trackColor: '#ccc',
    selectionColor: '#0091EA',
    trackColorSelected: '#ccc',
    handleColorZero: '#0091EA',
    rippleColor: 'white',
  },
  listItem: {
    textColor: 'blue',
  },
  stepper: {
    iconColor: '#0091EA',
    disabledTextColor: '#9E9E9E',
  },
  navBar: {
    height: '100px',
    background: '#0091EA',
  },
  checkbox: {
    checkedColor: '#784cab',
    boxColor: '#0a0a0a',
  },
  toolBar: {
    toolBarGrey: 'rgba(232, 232, 232, 1)',
    toolBarPurple: '#784cab',
    toolBarGreyText: 'rgba(10, 10, 10, 0.4)',
  },
  toast: {
    height: '100px',
  },
  mainBorder: '1px solid #DDDDDD',
  brandSuccess: '#784cab',
  ceoOrange: '#f4564e',
  ceoLightOrange: '#C70000',
  hopeBlack: '#0a0a0a',
  hopeLightBlack: '#1a1a1a',
  hopeBlue: '#0177C1',
  hopePurple: '#4527A0',
  hopeStars: '#A9A9A9',
  hopeGreen: '#29C688',
  hopeLightPurple: '#784cab',
  hopeWinePurple: '#492c66',
  hopeLightGreyPurple: '#43257c',
  hopeLightBlue: '#4527A0',
  hopeToyBlue: '#0091EA',
  hopeYellow: '#f7B801',
  hopeOrange: 'rgb(224, 122, 17)',
  hopeTextGrey: '#A9A9A9',
  hopeGreyPurple: '#6C698D',
  hopeLightGrey: '#DDDDDD',
  hopeDarkGrey: '#222222',
  hopeDarkPurple: '#352169',
  hopeLuxPurple: '#43247c',
  hopeButtonGradient: 'linear-gradient(to right,#4527A0,#784cab)',
  hopeButtonInverseGradient: 'linear-gradient(from right,#4527A0,#784cab)',
  hopeInvertedHover: '#E2CFEA',
  hopeRed: '#b3192e',
  brandRed: '#b3192e',
  brandRedHover: 'rgba(215, 67, 39, 0.8)',
  brandSuccessHover: '#4527A0',
  textColor: '#0a0a0a',
  fontWeight: '400',
  headerBold: '"Gotham A", "Gotham B", sans-serif',
  headerLight: '"Gotham A", "Gotham B", sans-serif',
  headerMedium: '"Gotham A", "Gotham B", sans-serif',
  weightBold: 'bold' as 'bold',
  weightLight: 'normal' as 'normal',
  weightMedium: 600 as 600,
  fontFamily: '"proxima-nova", "Helvetica Neue", Helvetica, Arial, sans-serif',
  palette: {
    navBarColor: white,
    primary1Color: '#784cab',
    primary2Color: cyan700,
    primary3Color: white,
    accent1Color: '#0a0a0a',
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: '#0a0a0a',
    primaryTextColor: '#1e2226',
    secondaryTextColor: white,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: grey400,
    pickerHeaderColor: cyan500,
    clockCircleColor: '#0a0a0a',
    shadowColor: '#0a0a0a',
  },
  avatar: { borderColor: null },
} as any;
